import React, { ReactElement } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import styles from "./wordTicker.module.scss";
import classNames from "classnames";

export const WordTicker = (props: Props): ReactElement => {
  return (
    <div className={styles.container}>
      <Swiper
        direction="vertical"
        autoplay={{
          delay: 1000,
          disableOnInteraction: false,
        }}
        resizeObserver={false}
        draggable={false}
        loop
        modules={[Autoplay]}
        slidesPerView={1}
        style={{ width: "100%", height: "100%" }}
      >
        {props.words.map((w, i) => (
          <SwiperSlide key={i} draggable={false}>
            <span
              className={classNames({
                [styles["blueG"]]: props.gradientType === "blue",
                [styles["greenG"]]: props.gradientType === "green",
              })}
            >
              {w}
            </span>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

interface Props {
  words: string[];

  delay?: number;
  gradientType: "blue" | "green";
}
